<template>
    <div>
        <vx-card>
            <div slot="no-body" class="tabs-container px-6 pt-6">
                <div class="vx-row mt-4">
                    <div class="vx-col md:w-1/4 w-full">
                        <vs-input class="w-full" :label="$t('root.functionName')"  placeholder="Nhập tên chức năng" v-model="permissionInfo.functionName"
                                  v-validate="'required'" name="namePermission"/>
                        <span class="text-danger text-sm">{{ errors.first('namePermission') }}</span>
                    </div>
                    <div class="vx-col md:w-1/4 w-full">
                        <vs-input class="w-full" :label="$t('root.displayName')" placeholder="Nhập tên hiển thị" v-model="permissionInfo.functionAlias"
                                  v-validate="'required'"
                                  name="namePermissionAlias"/>
                        <span class="text-danger text-sm">{{ errors.first('namePermissionAlias') }}</span>
                    </div>
                    <div class="vx-col md:w-1/4 w-full">
                        <vs-input class="w-full" :label="$t('liveStream.screen')" placeholder="Nhập màn hình" v-model="permissionInfo.groupPermission"
                                  v-validate="'required'"
                                  name="namePermissionGroup"/>
                        <span class="text-danger text-sm">{{ errors.first('namePermissionGroup') }}</span>
                    </div>
                    <div class="vx-col md:w-1/4 w-full">
                        <vs-input class="w-full" :label="$t('dashboard.arrange')" v-model="permissionInfo.displayOrder"
                                  name="displayOrder"/>
                    </div>
                </div>

                <div class="vx-row mt-4">
                    <div class="vx-col md:w-1/2 w-full">
                        <vs-input class="w-full" label="Api Path" placeholder="Api Path" v-model="permissionInfo.functionApiPrefix"
                                  v-validate="'required'" name="apiPath"/>
                        <span class="text-danger text-sm">{{ errors.first('apiPath') }}</span>
                    </div>

                    <div class="vx-col md:w-1/2 w-full">
                        <vs-input class="w-full" label="Screen Path" placeholder="Screen Path" v-model="permissionInfo.functionScreenPrefix"
                                  v-validate="'required'" name="screenPath"/>
                        <span class="text-danger text-sm">{{ errors.first('screenPath') }}</span>
                    </div>
                </div>

                <br>
                <br>

                <!-- Save & Reset Button -->
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <div class="mt-8 flex flex-wrap items-center justify-end mb-5">
                            <vs-button class="ml-auto mt-2" @click="saveChanges"
                                       :disabled="!validateForm"> {{ isUpdate ? $t('button.update') : $t('button.create')  }}
                            </vs-button>
                            <vs-button class="ml-4 mt-2" type="border" color="warning" @click="leaveList" v-if="!permissionId">{{  $t('button.back')}}
                            </vs-button>
                            <vs-button class="ml-4 mt-2" type="border" color="danger" @click="closePopup" v-else>Đóng
                            </vs-button>
                        </div>
                    </div>
                </div>
            </div>
        </vx-card>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>

import utils from "../../../components/utils";
// import moment from 'moment';
import 'quill/dist/quill.snow.css';

export default {
    components: {
        utils,
    },
    props: {
        permissionId: {
            type: Number,
            default: null,
        }
    },
    data() {
        return {
            isUpdate: false,
            permissionInfo: {},
        }
    },
    created() {
        this.initScreen();
        let timeDuration = 30, timeSpans = [];
        for (let i = 0; i < 24 * 60; i = i + timeDuration) {
            timeSpans.push({value: i, label: utils.minuteToHour(i)});
        }
        this.timeSpans = timeSpans;
        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.map(x => {
            return {label: x.organizationBranchName, value: x.id}
        });
        this.permissionInfo = {
            functionName: '',
            functionAlias: '',
            groupPermission: '',
            functionApiPrefix: '',
            functionScreenPrefix: '',
            displayOrder: 0,
            organizationId: 0,
        };
    },
    computed: {
        validateForm() {
            return !this.errors.any()
        },
    },
    methods: {
        successUpload() {
            this.$vs.notify({
                color: 'success',
                title: 'Upload Success',
                text: 'Lorem ipsum dolor sit amet, consectetur'
            })
        },
        onOptionClick({option, addTag}) {
            addTag(option)
            this.search = ''
        },
        getLabelString(object) {
            return (object && object.label) || 'Chưa xác định';
        },
        async initScreen() {
            try {
                if(!this.permissionId) {
                    this.isUpdate = false;
                    return
                }
                this.$vs.loading();
                const res = await this.$oauth.get(`permission-function-global/find-by-id/${this.permissionId}`)
                let permissionDetail = res.data;
                this.permissionInfo.functionName = permissionDetail.functionName;
                this.permissionInfo.functionAlias = permissionDetail.functionAlias;
                this.permissionInfo.groupPermission = permissionDetail.groupPermission;
                this.permissionInfo.functionApiPrefix = permissionDetail.functionApiPrefix;
                this.permissionInfo.functionScreenPrefix = permissionDetail.functionScreenPrefix;
                this.permissionInfo.displayOrder = permissionDetail.displayOrder;
                this.permissionId = permissionDetail.id;
                this.isUpdate = true;
                this.$vs.loading.close();
            }catch(err) {
                this.isUpdate = false;
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger',
                });
            }
        },
        async saveChanges(evt) {
            evt.preventDefault();
            try {
                if (!this.validateForm) return;

                const result = await this.$validator.validateAll();
                if (!result) return;

                let currentUser = JSON.parse(localStorage.getItem('userInfo') || '{}')

                let url = `/permission-function-global/create`;

                let params = {...this.permissionInfo, organizationId: currentUser.organization.id}

                if(this.isUpdate) {
                    url = `permission-function-global/update/${this.permissionId}`
                    params = {...params, id: this.permissionId}
                }

                this.$vs.loading();
                this.$oauth.post(url, params).then(() => {
                    this.$vs.loading.close();
                    this.$vs.notify({
                        color: 'success',
                        text: `${this.isUpdate ? 'Cập nhật' : 'Thêm'} thành công`,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                    });
                    if (this.permissionId) {
                        this.closePopup();
                    } else {
                        this.leaveList();
                    }
                }).catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            } catch (ex) {
                console.log(ex);
            }
        },
        leaveList() {
            this.$router.push(`/user/manage-permission`).catch(() => {
            })
        },
        closePopup() {
            this.$eventBus.$emit("update-permission-success", {});
        },
    },
}
</script>

<style scoped>
.input-content{
    height: 200px !important;
}
</style>
